<template>
  <v-btn depressed rounded class="account-activator" @click="setAccountSidebarExpanded(true)">
    <div class="d-none d-md-block account-activator__name">
      {{ currentUser.username }}
    </div>
    <span class="account-activator__avatar">
      <v-icon small color="#7b5cd6">mdi-account</v-icon>
    </span>
  </v-btn>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "MainAccount",
  data() {
    return {
      accountSidebar: false,
    };
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  methods: {
    ...mapMutations(["setAccountSidebarExpanded"]),
  },
};
</script>

<style lang="scss" scoped>
.account-activator {
  background: #edeafa !important;
  color: #6a4fc4 !important;
  text-transform: none;
  letter-spacing: 0;
  font-weight: 700;
  box-shadow: none !important;
  padding: 0 6px 0 18px !important;
  height: 40px !important;

  &__name {
    font-size: 14px;
  }

  &__avatar {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #fff;
    margin-left: 10px;
  }
}
</style>
